import { FC, useContext, useEffect, useState } from "react";
import { Button, CustomLink, Layout, Row } from "../../components";
import logo from "../../assets/logo.svg";
import { Context } from "../..";
import { useNavigate } from "react-router-dom";
import $api from "../../http";
import config from "../../config";
import styled from "styled-components";
import { observer } from "mobx-react";

const DateInput = styled.input`
  padding: 10px 15px;
  border-radius: 8px;
  border: 1px solid #ccc;
`;

const ReportPage: FC<{ title: string }> = observer(({ title }) => {
  const navigate = useNavigate();
  const { store } = useContext(Context);
  useEffect(() => {
    if (!store.isAuth) return navigate("/");
    if (store.user.type !== "admin") return navigate(`/${store.user.type}`);
  }, [navigate, store.isAuth, store.user.type]);

  const [selectDate, setSelectDate] = useState<string>(new Date().toLocaleDateString("ru"));
  const [reports, setReports] = useState<any[]>([]);
  useEffect(() => {
    $api.get(`${config.API}/master/reports?date=${selectDate}`).then(({ data }) => {
      setReports(data.data.reverse());
      console.log(data.data);
    });
  }, [selectDate]);

  const formatDate = (str: string) => {
    return `${str.split("-")[2]}.${str.split("-")[1]}.${str.split("-")[0]}`;
  };

  const exportToday = () => {
    $api.get(`${config.API}/master/exportreports?date=${selectDate}`).then(({ data }) => {
      window.open(`${config.API}/${data.data}`);
    });
  };

  const exportAll = () => {
    $api.get(`${config.API}/master/exportreports`).then(({ data }) => {
      window.open(`${config.API}/${data.data}`);
    });
  };

  return (
    <Layout title={title}>
      <img src={logo} alt="Chiorio logotype" width={120} height={120} />
      <CustomLink to="/admin">{"<-"} Админ-панель</CustomLink>
      <Row>
        <Button onClick={exportAll}>Скачать за всё время</Button>
        <DateInput type="date" onChange={({ target }) => setSelectDate(formatDate(target.value))} />
        <Button onClick={exportToday}>Скачать за этот день</Button>
      </Row>
      <div>
        {reports &&
          reports.map((e: any) => (
            <ul key={e._id}>
              {e.time}:<li>Посещений: {e.allJoins}</li>
              <li>Бесплатных: {e.allSixs}</li>
              <li>Время: {e.time}</li>
              <li>Терминал: {e.terminal}</li>
              <li>Сдают наличных: {e.allSalary}</li>
              <li>ЗП на карту: {e.card}</li>
              {e.stat.map((b: any) => (
                <li key={Math.random() * 1000}>
                  {b.name}: обслужено: {b.count}, зп: {b.money}, бесп: {b.sixCount} ({b.sixMoney}р)
                </li>
              ))}
            </ul>
          ))}
      </div>
    </Layout>
  );
});

export default ReportPage;
